import store from '@/store';
import { modalAlertNames, modalNames } from '@/components/common/globalComponent';

export const modalList = {
  ...modalAlertNames,
  ...modalNames
};

export const show = (component, data = {}, tag = '') => {
  store.dispatch('layout/pushModalComponent', { component, data, tag });
};
export const close = (tag = '') => {
  if (!tag) return store.dispatch('layout/removeAllModalComponent');
  const attachedList = store.getters['layout/getModalComponents'].map((elem) => elem.tag);

  const index = attachedList.findIndex((v) => {
    if (v === tag) return v;
  });
  return store.dispatch('layout/closeModalComponent', { index });
};
